import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// models
import { ApplicationSettings } from '../models/application-settings';
import { BuyerPermission } from '../models/buyer-permission';

// services
import { WebApiService } from './web-api.service';

@Injectable()
export class BuyerPermissionService {

  private apiPath: string;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'buyerpermission';
  }

  getBuyerPermissions(): Observable<Array<BuyerPermission>> {
    return this.webApiService.getList(this.apiPath);
  }
}
